import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import {
  ILineWatchdogSetting,
  ILineWatchdogSettingRow,
} from '../../../../view/settings/api-automation-settings/line-watchdog-settings/line-watchdog-settings.model';

@Injectable({
  providedIn: 'root',
})
export class LineWatchdogSettingService {
  private readonly LINE_WATCHDOG_SETTINGS_URL = `${this.baseUrl}/api-automation/line-watchdog-settings`;

  constructor(
    public http: HttpClient,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  public getData(params: HttpParams): Observable<GetManyResponseInterface<ILineWatchdogSetting>> {
    return this.http.get<GetManyResponseInterface<ILineWatchdogSetting>>(this.LINE_WATCHDOG_SETTINGS_URL, { params });
  }

  public getOne(recordId: number, params?: HttpParams): Observable<BaseOneResponseInterface<ILineWatchdogSetting>> {
    return this.http.get<BaseOneResponseInterface<ILineWatchdogSetting>>(
      `${this.LINE_WATCHDOG_SETTINGS_URL}/${recordId}`,
      { params },
    );
  }

  public addOne(record: ILineWatchdogSettingRow): Observable<BaseOneResponseInterface<ILineWatchdogSetting>> {
    return this.http.post<BaseOneResponseInterface<ILineWatchdogSetting>>(this.LINE_WATCHDOG_SETTINGS_URL, record);
  }

  public editOne(
    recordId: number,
    record: ILineWatchdogSettingRow,
  ): Observable<BaseOneResponseInterface<ILineWatchdogSetting>> {
    return this.http.patch<BaseOneResponseInterface<ILineWatchdogSetting>>(
      `${this.LINE_WATCHDOG_SETTINGS_URL}/${recordId}`,
      record,
    );
  }

  public deleteOnes(recordIds: number[]): Observable<BulkResponseDataInterface> {
    if (recordIds.length > 1) {
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        body: {
          lineWatchdogSettings: recordIds,
        },
      };

      return this.http.delete<BulkResponseDataInterface>(`${this.LINE_WATCHDOG_SETTINGS_URL}/bulk/delete`, httpOptions);
    }

    return this.http.delete<BulkResponseDataInterface>(`${this.LINE_WATCHDOG_SETTINGS_URL}/${recordIds[0]}`);
  }
}
